






















































































































































































































import Vue from "vue";
import { default as moment, Moment } from "moment-timezone";
import { forkJoin, interval, Subscription } from "rxjs";
import env from "../../environments/env.json";

import { Studio } from "@/api/Studio";

import {
  TermineService,
  TerminReihe,
  Termin,
  Dame,
  MassageArt,
  massagearten,
  fruehesterTermin,
  spaetesterTermin,
  formatDauerLesbar,
  currentTimestamp,
  getErsteAnzuzeigendeStunde,
  formatTime as _formatTime,
  PopoverMode,
  ContextMenuItem,
  ContextMenuItems,
  ContextMenuItemFunction,
  DAY_FORMAT,
  TIMEZONE,
  sortDamenAlnum,
} from "@/api/Termine";

import BelegungsplanContextMenu, {
  MenuItemSelected,
} from "./BelegungsplanContextMenu.vue";

import BelegungsplanPopover, {
  TerminUpdateEvent,
} from "./BelegungsplanPopover.vue";

import ConfirmDialog from "./ConfirmDialog.vue";

declare interface TerminFormatted extends Termin {
  cssClass?: string;
  styles?: string;
  dauerLesbar?: string;
  title?: string;
  editierbar: boolean;
  keinDienst: boolean;
}

interface Zeit {
  key: string;
  cssClass?: string;
  styles: string;
  stunde: number;
  zeitFormatted: string;
}

interface TerminReiheAufgeloest {
  dame: Dame;
  termine: TerminFormatted[];
}

const KEINE_DAME = "KEINE-DAME-PLATZHALTER";

export default Vue.extend({
  name: "Belegungsplan",
  components: {
    BelegungsplanContextMenu,
    BelegungsplanPopover,
    ConfirmDialog,
  },
  props: {
    studioBezeichner: {
      type: String,
      required: false,
      default: "darmstadt",
    },
    datum: {
      type: String,
      required: false,
      default: "01.06.2020",
    },
  },
  watch: {
    studioBezeichner: function(studioBezeichner) {
      console.debug("CMP / Studio-Bezeichner wechselt: " + studioBezeichner);
      this.setStudio(studioBezeichner);
    },
  },
  data() {
    const terminplan: TerminReiheAufgeloest[] = [];
    return {
      // Berechtigungen
      testfunktionenAktiviert: false,
      kannGeloeschteTermineSehen: false,

      // Terminplanungsdaten
      zeiten: [] as Zeit[],
      studio: {} as Studio,
      gewaehlterTag: "",
      datumLesbar: "",
      alleTermineZeitenSwitchValue: false,
      geloeschteTermineSwitchValue: false,
      heuteVerfuegbareDamen: [] as Dame[],
      terminplan,

      // Anzeigeeinstellungen
      fullscreen: false,
      autoRefreshSubscription: undefined as Subscription | undefined,
    };
  },
  computed: {
    heuteAusgewaehlt() {
      return (
        moment((this as any).gewaehlterTag)
          .format()
          .substring(0, 10) ==
        currentTimestamp()
          .format()
          .substring(0, 10)
      );
    },
    darfTageAuswaehlen() {
      return this.$znaApi.darfTageAuswaehlen();
    },
    darfTageLoeschen() {
      return this.$znaApi.darfTageLoeschen();
    },
    darfBuchhaltungTagesabschluss() {
      return this.$znaApi.darfBuchhaltungTagesabschluss();
    },
  },
  created() {
    console.debug("Belegungsplan created()");
    this.autoRefreshSubscription = interval(60000).subscribe(() => {
      const now = currentTimestamp();
      if (now.hour() >= 9 && now.hour() <= 22) {
        this.update();
      }
    });
  },
  mounted() {
    console.debug("Belegungsplan mounted()");
    this.testfunktionenAktiviert = !env.isProd;
    this.kannGeloeschteTermineSehen = this.$znaApi.darfGeloeschteTermine();
    this.setDate(this.datum);
    this.setStudio(this.studioBezeichner);
  },
  beforeDestroy() {
    this.autoRefreshSubscription?.unsubscribe();
    this.autoRefreshSubscription = undefined;
  },
  methods: {
    getRowKey(dame: Dame | null) {
      return dame?.kuenstlername || KEINE_DAME;
    },
    setDate(newDate: string) {
      this.gewaehlterTag = newDate;
      // Datum formatieren
      const datumISO = this.gewaehlterTag.split("T")[0];
      const [y, m, d] = datumISO.split("-");
      this.datumLesbar = `${d}.${m}.${y}`;
      this.$router.replace({
        path: `/termine/${this.studioBezeichner}/${datumISO}`,
      });
    },
    setStudio(studioBezeichner: string) {
      // Studio(-Name) und Termine abrufen
      this.$znaApi.getStudio(studioBezeichner).subscribe(
        (studio) => {
          if (studio) {
            this.studio = studio;
            this.$znaApi.setTitle(studio.name);
            this.update();
          }
        },
        (error) => {
          this.$toast.add({
            severity: "error",
            summary: "Studio konnte nicht ermittelt werden",
            detail: error,
            life: 3000,
          });
        }
      );
    },
    setZeitfenster(vonStunde: number, bisStunde: number) {
      const zeiten: Zeit[] = [];
      let hh = vonStunde;
      let col = 2;
      for (; hh < bisStunde - 1; hh++) {
        zeiten.push({
          key: "" + hh,
          cssClass: "vor",
          styles: `grid-column: ${col} / span 4`,
          stunde: hh,
          zeitFormatted: this.formatTime("" + hh),
        });
        col += 4;
      }
      {
        // Stunde vor Dienstschluss etwas kürzer
        zeiten.push({
          key: "" + hh,
          cssClass: "vor",
          styles: `grid-column: ${col} / span 3`,
          stunde: hh,
          zeitFormatted: this.formatTime("" + hh),
        });
        col += 3;
        // Stunde des Dienstschlusses
        hh++;
        zeiten.push({
          key: "" + hh,
          cssClass: "nach",
          styles: `grid-column: ${col}`,
          stunde: hh,
          zeitFormatted: this.formatTime("" + hh),
        });
      }
      this.zeiten = zeiten;
    },
    update() {
      if (!this.studio.id || !this.gewaehlterTag.length) {
        console.log(
          "Aktualisierung verhindert, Komponente noch nicht bereit/initialisiert"
        );
        return;
      }
      this.$store.dispatch("appLoading", true);
      console.log(this.alleTermineZeitenSwitchValue);
      const allesAnzeigen =
        this.alleTermineZeitenSwitchValue || !this.heuteAusgewaehlt;
      const updateZeiten = this.setZeitfenster.bind(this);

      const tag = moment(this.gewaehlterTag);
      forkJoin(
        this.$znaApi.getDienstplanTag(
          this.studio,
          tag,
          this.alleTermineZeitenSwitchValue
        ),
        this.$znaApi.getTermine(
          this.studio,
          tag,
          this.alleTermineZeitenSwitchValue
        )
      ).subscribe(
        ([dienstplan, terminplan]) => {
          const terminPlanInReihenfolge: {
            [kuenstlername: string]: TerminReihe;
          } = {};
          console.log("Verarbeite neue Planungs- und Termindaten");
          // Zeitfenster berechnen
          const aktuelleZeit = (() => {
            const jetzt = moment().tz(TIMEZONE);
            return jetzt.hours() + Math.round(jetzt.minutes() / 15) / 4;
          })();
          const ersteAnzuzeigendeStunde = getErsteAnzuzeigendeStunde(
            allesAnzeigen
          );
          let vonStunde = ersteAnzuzeigendeStunde;
          let bisStunde = Math.ceil(spaetesterTermin) | 0;
          const terminUhrzeitFilter = (von: Moment, bis: Moment) => {
            return (
              allesAnzeigen ||
              bis.hour() + bis.minutes() / 60 > (aktuelleZeit | 0)
            );
          };
          dienstplan.forEach((reihe) => {
            const von = moment(reihe.von);
            const bis = moment(reihe.bis);
            if (allesAnzeigen) {
              vonStunde = Math.min(von.hour(), vonStunde);
            }
            bisStunde = Math.max(bis.hour(), bisStunde);
          });
          terminplan
            .flatMap((reihe) => reihe.termine)
            .forEach((termin) => {
              const von = moment(termin.zeit);
              const bis = von.clone().add(termin.dauer * 60, "minutes");
              if (terminUhrzeitFilter(von, bis)) {
                vonStunde = Math.min(vonStunde, von.hour());
              }
              bisStunde = Math.max(
                bis.minute() == 0 ? bis.hour() : bis.hour() + 1,
                bisStunde
              );
            });
          console.log(`Von-Stunde: ${vonStunde}, Bis-Stunde: ${bisStunde}`);
          updateZeiten(vonStunde, bisStunde);

          // Blocker vor und nach eingetragenem Dienst generieren
          dienstplan.forEach((dienst) => {
            if (!terminPlanInReihenfolge[dienst.dame.kuenstlername]) {
              const termine: Termin[] = [];
              const von = moment(dienst.von);
              const bis = moment(dienst.bis);
              // 1/2: Gibt es einen Zeitraum zwischen Studioöffnung und Dienstantritt?
              if (
                vonStunde < von.hour() + von.minutes() / 60 &&
                bis.hour() < bisStunde
              ) {
                const dayStart = von
                  .clone()
                  .hour(vonStunde)
                  .minute(0);
                const dauer =
                  Math.round((von.unix() - dayStart.unix()) / 60 / 15) / 4;
                termine.push({
                  studio: dienst.studio,
                  dame: dienst.dame,
                  zeit: dayStart.format(),
                  dauer,
                  geblockt: true,
                  abgesagt: false,
                  gast: "(Noch) Kein Dienst",
                  keinDienst: true,
                } as Termin);
              }
              // 2/2: Gibt es einen Zeitraum nach Dienstende bis Studioschließung?
              if (bisStunde > bis.hour()) {
                const dauer = bisStunde - bis.hour() - bis.minute() / 60;
                termine.push({
                  geblockt: true,
                  zeit: dienst.bis,
                  dauer,
                  dame: dienst.dame,
                  abgesagt: false,
                  studio: dienst.studio,
                  gast: "Kein Dienst (mehr)",
                  keinDienst: true,
                } as Termin);
              }

              terminPlanInReihenfolge[dienst.dame.kuenstlername] = {
                dame: dienst.dame,
                termine,
              };
            }
          });

          // Termine in Terminplan eintragen
          terminplan.forEach((reihe) => {
            const kuenstlernameOderPlatzhalter =
              reihe.dame?.kuenstlername || KEINE_DAME;
            if (!terminPlanInReihenfolge[kuenstlernameOderPlatzhalter]) {
              terminPlanInReihenfolge[kuenstlernameOderPlatzhalter] = {
                dame: reihe.dame,
                termine: [],
              };
            }
            terminPlanInReihenfolge[kuenstlernameOderPlatzhalter].termine.push(
              ...reihe.termine.filter((termin) => {
                const von = moment(termin.zeit);
                const bis = von.clone().add(termin.dauer * 60, "minutes");
                return terminUhrzeitFilter(von, bis);
              })
            );
          });

          this.setTerminplan(
            [
              ...Object.keys(terminPlanInReihenfolge)
                .filter((key) => key != KEINE_DAME)
                .map((kuenstlername) => terminPlanInReihenfolge[kuenstlername]),
              terminPlanInReihenfolge[KEINE_DAME],
            ],
            vonStunde
          );
          this.$store.dispatch("appLoading", false);
        },
        (error) => {
          this.$toast.add({
            severity: "error",
            summary: "Laden der Daten fehlgeschlagen",
            detail: error,
            life: 3000,
          });
          this.terminplan = [];
          this.zeiten = [];
          this.$store.dispatch("appLoading", false);
        }
      );
    },
    setTerminplan(terminplan: TerminReihe[], vonStunde: number) {
      const zeigeGeloeschteTermine =
        this.kannGeloeschteTermineSehen && this.geloeschteTermineSwitchValue;
      const getCssClass = this.getCssClass;
      const getStyles = this.getStyles;
      const createTitle = this.createTitle;
      this.terminplan = [];
      terminplan.forEach((terminReihe) => {
        const termine: TerminFormatted[] = [];
        if (!terminReihe || !terminReihe.termine) {
          return;
        }
        terminReihe.termine.forEach((termin) => {
          if (!termin.abgesagt || zeigeGeloeschteTermine) {
            termine.push({
              id: termin.id,
              gast: termin.gast,
              massageart: termin.massageart,
              dame: termin.dame,
              dame2: termin.dame2,
              zeit: termin.zeit,
              dauer: termin.dauer,
              originalUhrzeit: termin.originalUhrzeit,
              abgesagt: termin.abgesagt,
              geblockt: termin.geblockt,
              preisManuell: termin.preisManuell,
              cssClass: getCssClass(termin),
              styles: getStyles(termin, vonStunde),
              dauerLesbar: formatDauerLesbar(termin.dauer),
              title: createTitle(termin),
              editierbar: !(termin as any).keinDienst,
              keinDienst: (termin as any).keinDienst,
            });
          }
        });
        this.terminplan.push({ dame: terminReihe.dame, termine });
      });
      this.terminplan.sort((reihe1, reihe2) => sortDamenAlnum(reihe1.dame, reihe2.dame));
      this.heuteVerfuegbareDamen = this.terminplan.map((reihe) => reihe.dame).sort(sortDamenAlnum);
    },
    wechsleTag(offset: number) {
      this.setDate(
        moment(this.gewaehlterTag)
          .add(offset, "day")
          .format()
      );
      this.update();
    },
    tagesabschluss() {
      this.$router.push({
        name: "Tagesabschluss",
        params: { studio: this.studioBezeichner, datum: this.gewaehlterTag },
      });
    },
    getCssClass(termin: Termin) {
      let cssClass = "termin";
      if (termin.abgesagt) {
        cssClass += " abgesagt";
      }
      if (termin.geblockt) {
        cssClass += " geblockt";
        if ((termin as any).keinDienst as boolean) {
          cssClass += " autogenerated";
        }
      }
      if (!termin.abgesagt && !termin.geblockt) {
        if (termin.massageart?.zweiteDame) {
          cssClass += " zwei-damen";
        } else {
          cssClass += " default";
        }
      }
      return cssClass;
    },
    getStyles(termin: Termin, vonStunde: number) {
      const zeit = moment(termin.zeit);
      const offset = (zeit.hour() - vonStunde) * 4 + zeit.minute() / 15 + 1;
      const viertelstunden = termin.dauer * 4;
      return `grid-column: ${offset} / span ${viertelstunden};`;
    },
    createTitle(termin: Termin) {
      return (
        "" +
        termin.gast +
        (termin.abgesagt ? " (abgesagt)" : "") +
        (termin.geblockt && !(termin as any).keinDienst ? " (geblockt)" : "")
      );
    },
    formatTime(zeit: string, minute = "00"): string {
      return _formatTime(zeit, minute);
    },
    openContextMenu(dame: Dame, termin: Termin) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        const e = event as MouseEvent;
        if (!dame) {
          dame = this.getDameFromCoordinates(e);
        }
        if (dame && dame.id) {
          const zeitslot = this.getZeitslot(e);
          console.debug("Klick war auf folgender Dame:");
          console.debug(dame);
          console.debug("Klick war auf folgender Stunde:");
          console.debug(zeitslot);
          const contextMenu = this.$refs.contextMenu as any;
          contextMenu.open(dame, zeitslot, termin);
        }
      }
    },
    neuerTermin() {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        const e = event as MouseEvent;
        const dame = this.getDameFromCoordinates(e);
        const zeitslot = this.getZeitslot(e);
        if (dame && dame.id) {
          this.showDialog("create", dame, undefined, zeitslot, undefined);
        }
      }
    },
    edit(termin: Termin) {
      if (event) {
        event.preventDefault();
      }
      this.showDialog("edit", termin.dame, termin.dame2, -1, termin);
    },
    getDameFromCoordinates(event: MouseEvent) {
      let damenIndex = -1;
      document
        .querySelectorAll(".chart .chart-row")
        .forEach((chartRow, index) => {
          if (index >= 2) {
            const rect = chartRow.getBoundingClientRect();
            if (
              event.pageX >= window.scrollX + rect.left &&
              event.pageX <= window.scrollX + rect.right &&
              event.pageY >= window.scrollY + rect.top &&
              event.pageY <= window.scrollY + rect.bottom
            ) {
              damenIndex = index - 2;
            }
          }
        });
      if (damenIndex > -1) {
        return this.terminplan[damenIndex].dame;
      }
      return {} as Dame;
    },
    getZeitslot(event: MouseEvent) {
      const srcElement = event.srcElement as any;
      const zeitslot =
        parseInt(srcElement.dataset.stunde) +
        parseInt(srcElement.dataset.minute) / 60;
      return zeitslot;
    },
    onMenuItemSelected(selectedEvent: MenuItemSelected) {
      this.showDialog(
        selectedEvent.popoverMode,
        selectedEvent.dame,
        selectedEvent.dame2,
        selectedEvent.zeitslot,
        selectedEvent.termin
      );
    },
    showDialog(
      popoverMode: PopoverMode,
      dame: Dame,
      dame2: Dame | undefined,
      zeitslot: number,
      termin: Termin | undefined
    ) {
      const popover: any = this.$refs.popover;
      this.$nextTick(() =>
        popover.show(
          popoverMode,
          dame,
          dame2,
          this.gewaehlterTag,
          zeitslot,
          termin
        )
      );
    },
    terminUpdated(update: TerminUpdateEvent) {
      console.log("Update Event received");
      switch (update.popoverMode) {
        case "delete":
          update.termin.abgesagt = true;
          break;
        case "block":
          update.termin.geblockt = true;
          break;
        case "duplicate":
          delete update.termin.id;
          break;
      }
      console.log(update);
      if (update.popoverMode != "info") {
        this.$znaApi
          .terminSpeichern(this.studio, update.termin)
          .subscribe(() => this.update());
      }
    },
    termineVerschieben() {
      this.$znaApi.termineAufHeute(this.studio).subscribe(console.log);
    },
    tagLoeschen() {
      this.$nextTick(() => {
        (this.$refs.confirmDialog as any)
          .confirm(
            "delete",
            "Gewählten Tag löschen?",
            `Sind Sie sicher, dass Sie sämtliche Buchungsdaten für den <strong>${this.datumLesbar}</strong> unwiederbringlich löschen möchten?`
          ).then(() => {
            this.$nextTick(() => {
              this.$store.dispatch("appLoading", true);
              this.$znaApi
                .tagesTermineLoeschen(this.studio, moment(this.gewaehlterTag))
                .subscribe(
                  () => {
                    this.update();
                    this.$toast.add({
                      severity: 'success',
                      summary: `Löschung erfolgreich ausgeführt`,
                      detail: `Alle Buchungsdaten für den ${this.datumLesbar} gelöscht.\nMonatsabschluss aktualisiert.`,
                      life: 5000
                      });
                  }, error => {
                    this.$toast.add({
                      severity: 'error',
                      summary: 'Fehler bei Datenlöschung',
                      detail: 'Leider kam es bei der Datenlöschung zu einem Fehler.\n\nBitte wenden Sie sich an den Programmierer und geben Sie genau an, was Sie getan haben und weshalb.',
                      life: 5000
                    });
                    this.$store.dispatch("appLoading", false);
                  });
            });
          },
          () => {
            this.$toast.add({
              severity: 'success',
              summary: 'Datenlöschung abgebrochen',
              detail: 'Okay, Schwein gehabt.\n\nBitte bei dieser Funktion wirklich aufpassen und einen kühlen Kopf bewahren.',
              life: 5000
            });
            this.$store.dispatch("appLoading", false);
          });
      });
    },
  },
});
